export default __webpack_public_path__ + "static/media/menu_close.7b5d92ea.svg";